'use es6';

import { CHATFLOWS_BY_UNIQUE_ID } from 'reference-resolvers/constants/CacheKeys';
import createBatchedReferenceResolver from 'reference-resolvers/lib/createBatchedReferenceResolver';
import { createGetChatflowsByUniqueId, getChatflowsByUniqueId } from 'reference-resolvers/api/ChatflowsByUniqueIdAPI';
export const createChatflowByUniqueIdReferenceResolver = options => createBatchedReferenceResolver(Object.assign({
  cacheKey: CHATFLOWS_BY_UNIQUE_ID,
  createFetchByIds: createGetChatflowsByUniqueId,
  fetchByIds: getChatflowsByUniqueId
}, options));
export default createChatflowByUniqueIdReferenceResolver();